export const MESSAGE_TYPES = {
    JOINED_CONVERSATION: 'joined-conversation',
    MESSAGE_WITH_ATTACHMENT: 'message-with-attachment',
} as const;

export type MessageType = (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];
